// extracted by mini-css-extract-plugin
export default {"heading":"ProductHeading_modern_heading__OLpId","rowOne":"ProductHeading_modern_rowOne__xy0X1","rowTwo":"ProductHeading_modern_rowTwo__uMlqA"};